export default "__VITE_ASSET__76ddc48a__"